import React, { useState, useCallback } from 'react'
import { useSelector } from 'react-redux'
import Link from 'redux-first-router-link'
import cn from 'classnames'
import { selectCurrentUserIsAdminOrOwner } from 'ducks/currentUser'
import { doOpenMainPage } from 'actions/pages'
import Menu from './Menu'
import ButtonWithMenu from '../ButtonWithMenu'

const SectionName = 'Conversations'
const toMainPage = doOpenMainPage()

const CentralizeSection = ({ className, active }) => {
  const isManager = useSelector(selectCurrentUserIsAdminOrOwner)
  const [open, setOpen] = useState(false)

  const handleCloseMenu = useCallback(() => {
    setOpen(false)
  }, [])

  if (!isManager) {
    return (
      <Link
        to={toMainPage}
        css={className}
        className={cn('grui mr-12', active === SectionName && 'active')}
      >
        {SectionName}
      </Link>
    )
  }

  return (
    <ButtonWithMenu
      css={className}
      open={open}
      isActive={active === SectionName}
      setOpen={setOpen}
      overlay={<Menu onClose={handleCloseMenu} />}
    >
      {SectionName}
    </ButtonWithMenu>
  )
}

export default CentralizeSection
